import { Component, OnInit, AfterViewInit, ViewChild } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { ErrorHandlerService } from "src/app/shared/error-handler.service";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import Swal from "sweetalert2";
import { GoalsService } from "@features/goals/services/goals.service";

interface GoalResponse {
  id: string;
  title: string;
  description: string;
  personName: string;
  status: string;
  startDate?: string;
  endDate?: string;
  createdAt?: string;
  updatedAt?: string;
}

@Component({
  selector: "app-goals-list",
  templateUrl: "./goals-list.component.html",
  styleUrls: ["./goals-list.component.css"],
})
export class GoalsListComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ["title", "personName", "startDate", "endDate", "status", "actions"];
  dataSource = new MatTableDataSource<GoalResponse>([]);
  loading = false;

  currentPage = 0;
  pageSize = 10;
  totalElements = 0;
  sortField = "title";
  sortDirection = "asc";
  filterValue = "";

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private goalsService: GoalsService,
    private toast: ToastrService,
    public router: Router,
    private errorHandlerService: ErrorHandlerService,
  ) {}

  ngOnInit(): void {
    this.loadGoals();
  }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe((sort: Sort) => this.onSortChange(sort));
  }

  private loadGoals(): void {
    this.loading = true;
    this.goalsService.findAll(this.currentPage, this.pageSize, this.sortField, this.sortDirection).subscribe({
      next: (response) => {
        if (response) {
          this.dataSource.data = response.content;
          this.totalElements = response.totalElements;
        }
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        this.errorHandlerService.handle(error, "Erro ao buscar as metas");
      },
    });
  }

  onPageChange(event: PageEvent): void {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadGoals();
  }

  onSortChange(sort: Sort): void {
    this.sortField = sort.active;
    this.sortDirection = sort.direction || "asc";
    this.currentPage = 0;
    this.loadGoals();
  }

  applyFilter(event: Event): void {
    const value = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = value;
  }

  statusLabel(status: string): string {
    const labels: Record<string, string> = {
      pending: "Pendente",
      pendente: "Pendente",
      in_progress: "Em Andamento",
      done: "Concluída",
      concluida: "Concluída",
      cancelled: "Cancelada",
      cancelada: "Cancelada",
    };
    return labels[status?.toLowerCase()] ?? status;
  }

  onEdit(goal: GoalResponse): void {
    this.router.navigate(["/goals/edit/", goal.id]);
  }

  onDelete(goal: GoalResponse): void {
    Swal.fire({
      title: `Tem certeza que deseja excluir a meta "${goal.title}"?`,
      text: "Você não poderá voltar atrás após excluir!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "green",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim, excluir agora!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.goalsService.delete(goal.id).subscribe({
          next: () => {
            this.toast.success(`A meta ${goal.title} foi excluída com sucesso.`);
            this.loadGoals();
          },
          error: (error) => {
            this.loading = false;
            this.errorHandlerService.handle(error, "Erro ao excluir meta selecionada.");
          },
        });
      }
    });
  }
}
